module.exports = __webpack_public_path__ + "static/media/mb-remoteup.6eb12808.png";